// extracted by mini-css-extract-plugin
export var container = "_5q-0";
export var fallback = "_5q-5";
export var fallbackIcon = "_5q-6";
export var hidden = "_5q-2";
export var image = "_5q-3";
export var loaded = "_5q-4";
export var placeholder = "_5q-1";